import * as XLSX from "xlsx";

export const cleanExcelFile = async (file, isContentID = false) => {
  const data = await file.arrayBuffer();
  const workbook = XLSX.read(data, { cellDates: true });

  if (workbook.SheetNames.length === 0) {
    throw new Error("No sheets found in Excel file");
  }

  const newWorkbook = XLSX.utils.book_new();

  workbook.SheetNames.forEach((sheetName) => {
    const ws = workbook.Sheets[sheetName];

    // Extract raw values only, no parsing or conversions
    // Filter out empty trailing rows that XLSX includes based on the sheet's !ref range
    const sheetData = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true })
      .filter((row, i) => i === 0 || row.some((cell) => cell != null && cell !== ""));

    // Add is_content_id column if isContentID is true
    if (isContentID && sheetData.length > 0) {
      // Check if is_content_id column already exists
      const headerRow = sheetData[0];
      const columnExists = headerRow && headerRow.includes("is_content_id");

      if (!columnExists) {
        // Get the number of columns in the header row
        const headerLength = headerRow ? headerRow.length : 0;

        // Add column header
        if (headerRow) {
          headerRow.push("is_content_id");
        }

        // Add value "true" for all data rows (using string for better Excel compatibility)
        for (let i = 1; i < sheetData.length; i++) {
          // Ensure row exists and is an array
          if (!sheetData[i]) {
            sheetData[i] = [];
          }
          if (Array.isArray(sheetData[i])) {
            // Pad the row to match header length before adding the new value
            while (sheetData[i].length < headerLength) {
              sheetData[i].push(null);
            }
            // Now add the is_content_id value
            sheetData[i].push("true");
          }
        }
      }
    }

    // Create a new sheet from plain array-of-arrays (no styles, no borders)
    const newWs = XLSX.utils.aoa_to_sheet(sheetData);

    // Do NOT copy !cols, !rows, !merges, or styles — that’s what we’re cleaning
    // (so Excel will recreate default column widths and plain cells)

    XLSX.utils.book_append_sheet(newWorkbook, newWs, sheetName);
  });

  const cleanedFileArray = XLSX.write(newWorkbook, {
    bookType: "xlsx",
    type: "array",
    cellDates: true,
  });

  const cleanedBlob = new Blob([cleanedFileArray], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  return new File([cleanedBlob], `cleaned_${file.name}`, {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
};
